import { react2angular } from 'react2angular';
import NoAccessAlert from './NoAccessAlert';

angular
  .module('bb.listing')
  .component('bbNoAccessAlert', react2angular(NoAccessAlert));
